<template>
    <div class="form-group">
        <label>Configurazione dati aggiuntivi</label>
        <button role="button"  aria-label=""  type="button" class="btn btn-success btn-sm ms-2" @click="showTempName = true" v-if="!showTempName">Aggiungi</button>
        <div v-if="showTempName" class="mt-2">
            <div class="form-group">
                <label>Nuovo campo aggiuntivo</label>
                <input type="text" class="form-control" placeholder="Nome del campo aggiuntivo (necessario e univoco)" v-model="tempName" />
                <div class="text-end mt-2">
                    <button role="button"  aria-label=""  type="button" class="btn btn-sm btn-success" :disabled="!canAddTempField" @click="addTempField">Avanti</button>
                </div>
            </div>
        </div>
        <div v-for="(item, i) in localValue" :key="i">
            <div class="d-flex align-items-center mt-2">
                <button role="button" class="btn btn-sm btn-danger me-2" @click="remove(i)">-</button>
                <button role="button" class="btn btn-sm btn-warning" @click="openConfigModal(item)">Configura campo</button>
                <div class="ms-2 d-flex align-items-center">
                    <div>
                        {{i + 1}}. {{item.name}} 
                    </div>
                    <div class="ms-2 label" v-if="item.required">
                        Obbligatorio
                    </div>
                    <div class="ms-2 label" v-if="item.isSelect">
                        Single select
                    </div>
                    <div class="ms-2 label" v-if="item.isMultiSelect">
                        Multiselect
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as Const from '@/const';
import * as VM from '@/viewmodel';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import formItemConfigModal from './formItemConfigModal.vue';

@Options({})
export default class formListConfig extends mixins(WithModel) {

    declare localValue: OM.FormItemConfig[];

    showTempName: boolean = false;
    tempName: string = "";

    get canAddTempField(){
        let isUnique = !this.localValue.some(x => x.name == this.tempName);
        return this.tempName.trim() != "" && isUnique;
    }

    addTempField(){
        if(!this.canAddTempField)
            return;

        this.tempName = this.tempName.trim();
        let toPush = new OM.FormItemConfig();
        toPush.name = this.tempName;
        this.localValue.push(toPush);
        this.showTempName = false;
        this.tempName = "";
    }

    openConfigModal(config: OM.FormItemConfig){
        this.$opModal.show(formItemConfigModal, {
            config: config
        })
    }

    remove(index: number){
        this.localValue.splice(index, 1);
    }

}
</script>

<style scoped>

</style>